import Vue from 'vue';
import dateFilter from './date-filter';
import timeFilter from './time-filter';
import dateDescriptionFilter from './date-description-filter';
import phoneFilter from './phone-filter';

Vue.filter('date', dateFilter);
Vue.filter('time', timeFilter);
Vue.filter('dateDescription', dateDescriptionFilter);
Vue.filter('phone', phoneFilter);
